import { RowDataReducerAction } from "../../../../../types";

export const addEmptyEnumForSubkey = (
  propertyKey: string,
  propertySubKey: string,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  dispatch({
    type: "UPDATE_SCHEMA_PROPERTY_FIELD",
    payload: {
      propertyKey,
      propertySubKey,
      propertyField: "enum",
      newPropertyFieldValue: [],
    },
  });
};
